export enum AccessRole {
    ADMIN_SEC = "ADMIN_SEC",
    ADMIN_SEG = "ADMIN_SEG",
    ADMIN_FORM = "ADMIN_FORM",
    ADMIN_TRAM = "ADMIN_TRAM",
    ADMIN_DASHBOARD = "ADMIN_DASHBOARD",
    ADMIN_TRAM_IMPUESTO = "ADMIN_TRAM_IMPUESTO",
    GESTION_TRAMITE = "GESTION_TRAMITE",
    ADMIN_PQRSD = "ADMIN_PQRSD",
    GESTION_PQRSD = "GESTION_PQRSD",
    ASIGNACION_MANUAL = "ASIGNACION_MANUAL",
    GESTION_FIRMA_ELECTRONICA = "GESTION_FIRMA_ELECTRONICA",
    CHAT_CLIENT_DEV = "CHAT_CLIENT_DEV",
    SISBEN = "SISBEN"
}
